<template>
  <v-col cols="5" style="margin:2em">
    <h4>Facturas Pendientes de cobro</h4>
    <v-card style="padding: 1em">
      <v-simple-table style="background-color: #fff !important;" v-if="invoices.length > 0">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Nº Factura</th>
              <th class="text-left">Empresa</th>
              <th class="text-left">Fecha</th>
              <th class="text-left">Cantidad</th>

            </tr>
          </thead>
          <tbody>
            <tr v-for="invoice in invoices" :key="invoice.invoiceNumber">
              <td>0000000{{ invoice.invoiceNumber }}/{{ invoice.date_add.split("-")[0] }}</td>
              <td>{{ invoice.fiscalName }}</td>
              <td>{{ invoice.date_add }}</td>
              <td>{{ getParseTotal(invoice.total) }}€</td>

            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <h3 v-else style="text-align: center">No hay facturas pendientes</h3>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "pendingInvoices",
  props: ['invoices', 'refresh'],
  methods: {
    getParseTotal(total) {
      return parseFloat(total).toFixed(2)
    },
    setPaidInvoice(iid) {
      this.loaded = false;
      let url = this.base_url + '/invV2/admin/pagarfactura';
      let formData = new FormData();
      formData.set('token', localStorage.token);
      formData.set('iid', iid);
      this.axios.post(url, formData).then(() => {
        this.refresh();
      });
    }
  }
}
</script>